module.exports = __webpack_public_path__ + "fonts/Raleway-BlackItalic.82163a0f.ttf";